<div class="container-fluid bg-white vh-100 p-0">
    <div class="d-flex flex-column align-items-center min-vh-50">
      <div class="col-11 col-sm-10 col-md-8 col-lg-6 col-xl-5 p-3">
        <div class="d-flex align-items-center">
          <span><i class="text-muted bi bi-question-circle me-2"></i></span>
          <span class="text-muted text-xs">Completing these qualifying criteria and declarations is required when applying for finance to assess your eligibility and confirm your acceptance of terms and conditions.</span>
        </div>
        
        <div class="form-group mt-4">
          <div class="mb-3 border p-3 rounded shadow-sm">
          <h5 class="fw-bold mb-3">Qualifying Criteria</h5>
            <div class="form-check">
              <input v-model="credit_check_consent" type="checkbox" class="form-check-input" id="credit_check_consent" :required="true"/>
              <label class="form-check-label text-xs" for="credit_check_consent">
                By clicking Apply or Print, all Parties hereto, whether individual or joint, hereby consent the Banks to access their credit profile from the credit bureaus for the purposes of a credit assessment and in the event that the loan application is successful, for on-going account maintenance purposes, setting limits, development of credit tools/products/models and insurance purposes.
              </label>
            </div>
            <small v-if="error_messages.credit_check_consent" class="form-text text-danger text-xs fw-bold">
              {{ error_messages.credit_check_consent }}
          </small>
          </div>
          
          <div class="mb-3 border p-3 rounded shadow-sm">
          <h5 class="fw-bold mb-3">Declarations</h5>

            <div class="row g-2">
              <div class="col-md-6 mb-2">
                <label class="fw-bold text-xs mb-2">I am insolvent <span class="text-danger">*</span></label>
                <div class="d-flex">
                  <div class="form-check me-3">
                    <input v-model="client_insolvent_ind" type="radio" class="form-check-input" id="insolvent_yes" name="client_insolvent_ind" value="YES" required />
                    <label class="form-check-label text-xs" for="insolvent_yes">Yes</label>
                  </div>
                  <div class="form-check">
                    <input v-model="client_insolvent_ind" type="radio" class="form-check-input" id="insolvent_no" name="client_insolvent_ind" value="NO" required />
                    <label class="form-check-label text-xs" for="insolvent_no">No</label>
                  </div>
                </div>
                <small v-if="error_messages.client_insolvent_ind" class="form-text text-danger text-xs fw-bold">
                  {{ error_messages.client_insolvent_ind }}
              </small>
              </div>
              
              <div class="col-md-6 mb-2">
                <label class="fw-bold text-xs mb-2">I am currently subject to an Administration Order <span class="text-danger">*</span></label>
                <div class="d-flex">
                  <div class="form-check me-3">
                    <input v-model="client_admin_order_ind" type="radio" class="form-check-input" id="admin_order_yes" name="client_admin_order_ind" value="YES" required />
                    <label class="form-check-label text-xs" for="admin_order_yes">Yes</label>
                  </div>
                  <div class="form-check">
                    <input v-model="client_admin_order_ind" type="radio" class="form-check-input" id="admin_order_no" name="client_admin_order_ind" value="NO" required />
                    <label class="form-check-label text-xs" for="admin_order_no">No</label>
                  </div>
                </div>
                <small v-if="error_messages.client_admin_order_ind" class="form-text text-danger text-xs fw-bold">
                  {{ error_messages.client_admin_order_ind }}
              </small>
              </div>
            </div>

            <div class="row g-2">
              <div class="col-md-6 mb-2">
                <label class="fw-bold text-xs mb-2">I am currently under sequestration <span class="text-danger">*</span></label>
                <div class="d-flex">
                  <div class="form-check me-3">
                    <input v-model="client_sequestrian_order_ind" type="radio" class="form-check-input" id="sequestrian_order_yes" name="client_sequestrian_order_ind" value="YES" required />
                    <label class="form-check-label text-xs" for="sequestrian_order_yes">Yes</label>
                  </div>
                  <div class="form-check">
                    <input v-model="client_sequestrian_order_ind" type="radio" class="form-check-input" id="sequestrian_order_no" name="client_sequestrian_order_ind" value="NO" required />
                    <label class="form-check-label text-xs" for="sequestrian_order_no">No</label>
                  </div>
                </div>
                <small v-if="error_messages.client_sequestrian_order_ind" class="form-text text-danger text-xs fw-bold">
                  {{ error_messages.client_sequestrian_order_ind }}
              </small>
              </div>
              
              <div class="col-md-6 mb-2">
                <label class="fw-bold text-xs mb-2">I am currently under debt review <span class="text-danger">*</span></label>
                <div class="d-flex">
                  <div class="form-check me-3">
                    <input v-model="client_debt_review_ind" type="radio" class="form-check-input" id="debt_review_yes" name="client_debt_review_ind" value="YES" required />
                    <label class="form-check-label text-xs" for="debt_review_yes">Yes</label>
                  </div>
                  <div class="form-check">
                    <input v-model="client_debt_review_ind" type="radio" class="form-check-input" id="debt_review_no" name="client_debt_review_ind" value="NO" required />
                    <label class="form-check-label text-xs" for="debt_review_no">No</label>
                  </div>
                </div>
                <small v-if="error_messages.client_debt_review_ind" class="form-text text-danger text-xs fw-bold">
                  {{ error_messages.client_debt_review_ind }}
              </small>
              </div>
            </div>
            
            <div class="row g-2">
              <div class="col-md-6 mb-2">
                <label class="fw-bold text-xs mb-2">I am currently liable as a guarantor <span class="text-danger">*</span></label>
                <div class="d-flex">
                  <div class="form-check me-3">
                    <input v-model="client_guarantor_ind" type="radio" class="form-check-input" id="guarantor_yes" name="client_guarantor_ind" value="YES" required />
                    <label class="form-check-label text-xs" for="guarantor_yes">Yes</label>
                  </div>
                  <div class="form-check">
                    <input v-model="client_guarantor_ind" type="radio" class="form-check-input" id="guarantor_no" name="client_guarantor_ind" value="NO" required />
                    <label class="form-check-label text-xs" for="guarantor_no">No</label>
                  </div>
                </div>
                <small v-if="error_messages.client_guarantor_ind" class="form-text text-danger text-xs fw-bold">
                  {{ error_messages.client_guarantor_ind }}
              </small>
              </div>
              
              <div class="col-md-6 mb-2">
                <label class="fw-bold text-xs mb-2">I am currently liable as a surety <span class="text-danger">*</span></label>
                <div class="d-flex">
                  <div class="form-check me-3">
                    <input v-model="client_surety_ind" type="radio" class="form-check-input" id="surety_yes" name="client_surety_ind" value="YES" required />
                    <label class="form-check-label text-xs" for="surety_yes">Yes</label>
                  </div>
                  <div class="form-check">
                    <input v-model="client_surety_ind" type="radio" class="form-check-input" id="surety_no" name="client_surety_ind" value="NO" required />
                    <label class="form-check-label text-xs" for="surety_no">No</label>
                  </div>
                </div>
                <small v-if="error_messages.client_surety_ind" class="form-text text-danger text-xs fw-bold">
                  {{ error_messages.client_surety_ind }}
              </small>
              </div>
            </div>

            <div class="row g-2">
              <div class="col-md-6 mb-2">
                <label class="fw-bold text-xs mb-2">I am currently liable as a co-debtor <span class="text-danger">*</span></label>
                <div class="d-flex">
                  <div class="form-check me-3">
                    <input v-model="client_co_debtor_ind" type="radio" class="form-check-input" id="co_debtor_yes" name="client_co_debtor_ind" value="YES" required />
                    <label class="form-check-label text-xs" for="co_debtor_yes">Yes</label>
                  </div>
                  <div class="form-check">
                    <input v-model="client_co_debtor_ind" type="radio" class="form-check-input" id="co_debtor_no" name="client_co_debtor_ind" value="NO" required />
                    <label class="form-check-label text-xs" for="co_debtor_no">No</label>
                  </div>
                </div>
                <small v-if="error_messages.client_co_debtor_ind" class="form-text text-danger text-xs fw-bold">
                  {{ error_messages.client_co_debtor_ind }}
              </small>
              </div>
  
              <div class="col-md-6 mb-2">
                <label class="fw-bold text-xs mb-2">I am currently under debt rearrangement <span class="text-danger">*</span></label>
                <div class="d-flex">
                  <div class="form-check me-3">
                    <input v-model="client_debt_rearrangement_ind" type="radio" class="form-check-input" id="debt_rearrangement_yes" name="client_debt_rearrangement_ind" value="YES" required />
                    <label class="form-check-label text-xs" for="debt_rearrangement_yes">Yes</label>
                  </div>
                  <div class="form-check">
                    <input v-model="client_debt_rearrangement_ind" type="radio" class="form-check-input" id="debt_rearrangement_no" name="client_debt_rearrangement_ind" value="NO" required />
                    <label class="form-check-label text-xs" for="debt_rearrangement_no">No</label>
                  </div>
                </div>
                <small v-if="error_messages.client_debt_rearrangement_ind" class="form-text text-danger text-xs fw-bold">
                  {{ error_messages.client_debt_rearrangement_ind }}
                </small>
              </div>
            </div>
            
            <div class="row g-2">
              <div class="col-md-6 mb-2">
                <label class="fw-bold text-xs mb-2">I am currently subject to a garnishee order <span class="text-danger">*</span></label>
                <div class="d-flex">
                  <div class="form-check me-3">
                    <input v-model="client_garnishee_order_ind" type="radio" class="form-check-input" id="garnishee_order_yes" name="client_garnishee_order_ind" value="YES" required />
                    <label class="form-check-label text-xs" for="garnishee_order_yes">Yes</label>
                  </div>
                  <div class="form-check">
                    <input v-model="client_garnishee_order_ind" type="radio" class="form-check-input" id="garnishee_order_no" name="client_garnishee_order_ind" value="NO" required />
                    <label class="form-check-label text-xs" for="garnishee_order_no">No</label>
                  </div>
                </div>
                <small v-if="error_messages.client_garnishee_order_ind" class="form-text text-danger text-xs fw-bold">
                  {{ error_messages.client_garnishee_order_ind }}
                </small>
              </div>
  
              <div class="col-md-6 mb-2">
                <label class="fw-bold text-xs mb-2">I am currently involved in a credit dispute <span class="text-danger">*</span></label>
                <div class="d-flex">
                  <div class="form-check me-3">
                    <input v-model="client_credit_dispute_ind" type="radio" class="form-check-input" id="credit_dispute_yes" name="client_credit_dispute_ind" value="YES" required />
                    <label class="form-check-label text-xs" for="credit_dispute_yes">Yes</label>
                  </div>
                  <div class="form-check">
                    <input v-model="client_credit_dispute_ind" type="radio" class="form-check-input" id="credit_dispute_no" name="client_credit_dispute_ind" value="NO" required />
                    <label class="form-check-label text-xs" for="credit_dispute_no">No</label>
                  </div>
                </div>
                <small v-if="error_messages.client_credit_dispute_ind" class="form-text text-danger text-xs fw-bold">
                  {{ error_messages.client_credit_dispute_ind }}
                </small>
              </div>
            </div>

            <div class="row g-2">
              <div class="col-md-6 mb-2">
                <label class="fw-bold text-xs mb-2">I am currently undergoing credit rehabilitation <span class="text-danger">*</span></label>
                <div class="d-flex">
                  <div class="form-check me-3">
                    <input v-model="credit_rehabilitation_ind" type="radio" class="form-check-input" id="credit_rehabilitation_yes" name="credit_rehabilitation_ind" value="YES" required />
                    <label class="form-check-label text-xs" for="credit_rehabilitation_yes">Yes</label>
                  </div>
                  <div class="form-check">
                    <input v-model="credit_rehabilitation_ind" type="radio" class="form-check-input" id="credit_rehabilitation_no" name="credit_rehabilitation_ind" value="NO" required />
                    <label class="form-check-label text-xs" for="credit_rehabilitation_no">No</label>
                  </div>
                </div>
                <small v-if="error_messages.credit_rehabilitation_ind" class="form-text text-danger text-xs fw-bold">
                  {{ error_messages.credit_rehabilitation_ind }}
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div class="text-center mb-3 mt-4">
        <button type="button" @click="$emit('previous')" class="btn btn-bg-secondary text-xs fw-bold rounded-small shadow-sm me-1">
          Previous
        </button>
        <button class="btn btn-sm bg-green text-dark rounded-small fw-bold secondary-text-dark shadow-sm" @click="submit_declarations">
          Continue
        </button>
      </div>
    </div>
  </div>